import { RolesManagement } from 'pages/roles';
import React from 'react';
import { useAdminRoleManagementData } from './useAdminRoleManagementData';

export const AdminRoleManagement: React.FC = () => {
  const {
    roles,
    organizations,
    permissions,
    isLoading,
    isError,
    isFetching,
    errorMessage,
  } = useAdminRoleManagementData();
  return (
    <RolesManagement
      roles={roles}
      organizations={organizations}
      permissions={permissions}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
